import type { BoggleCompletedRun } from '~/boggle/progress/types'
import { formatBogglePlayedDateTime } from '~/boggle/ui/formatBogglePlayedDateTime'

const RUN_HISTORY_INVALID = {
  date: 'Run date unavailable',
  time: 'Run time unavailable',
} as const

export function sortBoggleCompletedRunsNewestFirst(runs: readonly BoggleCompletedRun[]) {
  return [...runs].sort((a, b) => {
    const completedOrder = b.completedAt.localeCompare(a.completedAt)
    if (completedOrder !== 0) {
      return completedOrder
    }

    const startedOrder = b.startedAt.localeCompare(a.startedAt)
    return startedOrder !== 0 ? startedOrder : b.id.localeCompare(a.id)
  })
}

export function formatBoggleRunHistoryPlayedDate(isoString: string) {
  return formatBogglePlayedDateTime(isoString).date
}

export function formatBoggleRunHistoryFiniteNumber(value: number | undefined) {
  return typeof value === 'number' && Number.isFinite(value) ? String(value) : '—'
}

export function formatBoggleRunDetailsPlayedDateTime(isoString: string) {
  return formatBogglePlayedDateTime(isoString, RUN_HISTORY_INVALID)
}
